module.exports = "/images/hard-hat.svg";